export const BTN = {
  label: 'Install App',
  type: 'primary',
  size: 'small'
};
